import React from "react";
import {
  Headline,
  SectionContent,
  ContentWithImage,
  Accordion,
  Text,
  List,
  Link,
  ActionChat,
} from "../../../../components";
import CalendarioDeSorteios from "../../../../assets/images/capitalizacao/ilustracao-calendario-de-sorteios.svg";
import ImageNavigationLink from "../../../../assets/images/capitalizacao/ilustracao-mulher-trofeu.svg";
import { chatIdCapitalizacao, links } from "../../../../config";

const faqList = [
  {
    title: "O que é a  capitalização?",
    body: (
      <>
        <Text textSize="sm">
          A capitalização é uma maneira de concorrer a vários prêmios
          milionários que podem mudar sua vida e ainda, guardar dinheiro. Você
          escolhe se guarda uma só vez ou mensalmente, por um determinado prazo.
        </Text>
        <Text textSize="sm">
          Você ganha concorrendo nos sorteios e também ao final, ou seja, tudo
          que juntou durante o prazo do seu título, está lá pra realizar suas
          conquistas.
        </Text>
      </>
    ),
  },
  {
    title: "Capitalização é diferente de jogos ou investimentos?",
    body: (
      <>
        <Text textSize="sm">
          Quando você adquire um título de capitalização, você está optando por
          um jeito diferente de guardar dinheiro. Capitalização não pode ser
          comparada a outros produtos financeiros porque não está na categoria
          de investimentos. Você troca a possível rentabilidade de um
          investimento, pela chance de ser sorteado com um prêmio milionário.
        </Text>
        <Text textSize="sm">
          Quando você aplica seu dinheiro em um investimento, ele normalmente
          não oferece chances de você ser premiado. Capitalização também não
          pode ser comparada com as loterias, pois as loterias não devolvem o
          valor da aposta.
        </Text>
        <Text textSize="sm">
          Na capitalização, você recebe 100% do valor guardado de volta,
          atualizado pela Taxa Referencial de juros (TR), mesmo se não for
          sorteado.
        </Text>
        <Text textSize="sm">
          E não é que uma seja melhor que a outra. Cada uma tem um jeito de
          cuidar do seu dinheiro. Cabe a você escolher a que melhor se encaixa
          ao seu perfil e suas necessidades.
        </Text>
      </>
    ),
  },
  {
    title: "O que é a Taxa Referencial de juros?",
    body: (
      <Text textSize="sm">
        A Taxa Referencial (TR) de juros é uma taxa mensal de correção
        monetária. Ela garante resgatar todo o valor que você pagou pela
        capitalização.
      </Text>
    ),
  },
  {
    title: "Como funcionam os sorteios?",
    body: (
      <>
        <Text textSize="sm">
          No título de capitalização você encontra os números da sorte que
          concorrem aos prêmios com outras pessoas que têm títulos da mesma
          série que a sua (mesmo prazo, produto, quantidade de sorteios e outros
          fatores).
        </Text>

        <Text textSize="sm">
          As combinações são distribuídas de forma aleatória e todos têm as
          mesmas chances de ganhar, pois um título jamais possui as mesmas
          combinações de outro dentro de uma mesma série. Aquele que for igual
          ao do sorteio realizado pela Loteria Federal ou por nós, será o
          vencedor.
        </Text>
        <Text textSize="sm">
          Os sorteios são realizados, nos quatro últimos sábados de cada mês
          pela Loteria Federal e nas quatro últimas sextas-feiras de cada mês em
          nossa sede, conforme o título adquirido. Lembrando que, todos os
          sorteios são acompanhados por empresas de auditoria independente.
        </Text>

        <Text textSize="sm">Que a sorte esteja com você!</Text>
      </>
    ),
  },
  {
    title: "Posso mudar de vida com a capitalização?",
    body: (
      <>
        <Text textSize="sm">
          Quem nunca imaginou comprar a casa dos sonhos ou reformar do seu
          jeito, conquistar o carro do ano, fazer uma viagem inesquecível,
          investir no próprio negócio ou ter dinheiro suficiente para quitar as
          dívidas e ficar numa boa?
        </Text>

        <Text textSize="sm">
          A capitalização pode realizar todos esses sonhos. É só torcer pra
          sorte e manter todos os seus dados atualizados pra que a gente possa
          te avisar caso seja um dos ganhadores.
        </Text>
        <Text textSize="sm">
          O mais legal de tudo é que mesmo sendo sorteado uma vez, você pode
          continuar participando dos próximos sorteios. Mas lembre-se: você só
          começa a concorrer após a confirmação do pagamento.
        </Text>
      </>
    ),
  },
  {
    title: "E se eu não for sorteado?",
    body: (
      <Text textSize="sm">
        Se você não ganhar nenhum sorteio, não significa que você perdeu. Pelo
        contrário. Lembra do dinheiro que você guardou? Quando o prazo do seu
        título terminar, você recebe todo o valor de volta conforme as condições
        gerais do seu título.
      </Text>
    ),
  },
  {
    title: "Quais são os serviços que eu posso fazer on-line?",
    body: (
      <List
        styleType="disc"
        listItems={[
          <>Conferir se foi sorteado;</>,
          <>
            Atualizar seus dados (afinal, você quer ser avisado se ganhar nos
            sorteios, não é mesmo?);
          </>,
          <>Solicitar a segunda via do seu título;</>,
          <>
            Consultar as informações do título: vigência, número da sorte,
            saldo, informe de Imposto de Renda)
          </>,
          <>Alterar a forma de pagamento</>,
        ]}
        forEach={(item) => <Text textSize="sm">{item}</Text>}
      />
    ),
  },
  {
    title: "Quando acontecem os sorteios?",
    body: (
      <>
        <Text textSize="sm">
          Os sorteios são realizados, nos quatro últimos sábados de cada mês
          pela Loteria Federal e nas quatro últimas sextas-feiras de cada mês,
          em nossa sede, conforme o título adquirido e você pode consultar o
          resultado aqui no nosso site.
        </Text>
        <img src={CalendarioDeSorteios} alt="" />
      </>
    ),
  },
  {
    title: "Fui sorteado, como receber meu prêmio?",
    body: (
      <Text textSize="sm">
        Os pagamentos dos prêmios acontecem em até 15 dias úteis, após a data do
        sorteio. Para conseguirmos dar essa notícia pra você por e-mail, SMS,
        ligação ou correspondência, não esqueça de manter seus dados sempre
        atualizados na{" "}
        <Link
          href={links.capitalizacao.areaLogada}
          target="_blank"
          label="Área do Cliente"
        />{" "}
        ou fale com a gente pelo telefone{" "}
        <Link href="tel:0800 274 1000" label="0800 274 1000" /> das 8h às 21h,
        de segunda a sexta, exceto em feriados nacionais.
      </Text>
    ),
  },
  {
    title: "E se eu deixar de pagar alguma mensalidade?",
    body: (
      <Text textSize="sm">
        Se você optar pelo produto mensal e não estiver com o pagamento em dia,
        você não vai concorrer aos sorteios daquele mês. Se você tem mais de
        quatro mensalidades consecutivas sem pagamento, entre em contato pelo{" "}
        <ActionChat chatId={chatIdCapitalizacao} as={Link} label="chat" /> ou
        pela Central de Serviços e Relacionamento. Ligue{" "}
        <Link href="tel:0800 274 1000" label="0800 274 1000" /> das 8h às 21h,
        de segunda a sexta, exceto em feriados nacionais.
      </Text>
    ),
  },
  {
    title: "E se eu quiser retirar o dinheiro guardado, o que eu faço?",
    body: (
      <>
        <Text textSize="sm">
          Para o produto de pagamento mensal, você resgata 100% do que foi pago,
          se mantiver todas as mensalidades em dia e ficar até o final do plano.
          Você pode resgatar a qualquer momento, solicitando um resgate
          antecipado. Porém, parte do valor pago será disponibilizado após o
          período de carência (12 primeiros meses em caso de título de pagamento
          mensal).
        </Text>
        <Text textSize="sm">
          Para o produto que você paga uma única vez, você também recebe 100% do
          dinheiro se ficar até o final do plano. Mas neste caso, a carência é
          de 30 dias para o resgate antecipado. Sabe por quê? Nós fazemos um
          compromisso com você e com as pessoas que compraram um título de
          capitalização: todos guardam seu dinheiro com a gente e, em troca,
          concorrem aos nossos prêmios milionários.
        </Text>
        <Text textSize="sm">
          O mais indicado mesmo é deixar o seu dinheiro bem guardado para
          continuar participando dos sorteios e, no final, receber todo o valor
          que pagou.
        </Text>
        <Text textSize="sm">
          Nas condições gerais do seu produto você encontra a tabela com os
          percentuais para resgates antes do prazo. Se o prazo de vigência do
          seu título terminou ou se você quer resgatar antes da hora, fale com a
          gente pelo{" "}
          <ActionChat chatId={chatIdCapitalizacao} as={Link} label="chat" /> ou
          pela Central de Serviços e Relacionamento. Ligue{" "}
          <Link href="tel:0800 274 1000" label="0800 274 1000" /> das 8h às 21h,
          de segunda a sexta, exceto em feriados nacionais.
        </Text>
        <Text textSize="sm">
          <strong>
            Atenção clientes SuperXcap, você também tem a opção de realizar o
            resgate em qualquer casa lotérica. Não esqueça do título impresso e
            identificação pessoal. ;)
          </strong>
        </Text>
      </>
    ),
  },
];

const SaibaMais = () => {
  return (
    <SectionContent>
      <ContentWithImage
        imgColumnSize={6}
        imgSrc={ImageNavigationLink}
        imgAlt="imgAlt"
        hideMobile
      >
        <Headline styleAs="4" nivel="2">
          Saiba mais sobre a sua Capitalização
        </Headline>
        <Accordion listItems={faqList} />
      </ContentWithImage>
    </SectionContent>
  );
};

SaibaMais.propTypes = {};

export default SaibaMais;
